import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { NutritionIngredientEvent } from './nutrition_events';

@Injectable({ providedIn: 'root' })
export class NutritionIngredientEventProvider extends DomainEventProvider<NutritionIngredientEvent> {}
